<template lang="html">
    <!-- same as the previous modal -->
    <!-- second component for superposition of modals -->
    <v-dialog v-model="isOpen" :max-width="width" :fullscreen="fullscreen" @keydown.enter="warning ? close('close') : validate()" @keydown.esc="close" :persistent="true">
        <v-card>
            <v-card-title :class="{ 'warning' : warning }" v-if="title != null">
                <h2>
                    <v-icon v-if="warning">warning</v-icon>
                    <v-icon v-if="!warning && icon">{{ icon }}</v-icon>
                    <span>{{ title }}</span>
                </h2>
                <v-btn small icon @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text :class="card_text_class">
                <template v-if="currentView">
                    <component :is="currentView" :params="params" ref="currentView"></component>
                </template>
            </v-card-text>

            <v-card-actions v-if="currentView != null && actions === true">
                <v-btn round small flat :color="warning ? 'warning' : 'primary'" v-if="cancel_button" @click.native="close('cancel')">{{cancel_label}}</v-btn>
                <v-btn round depressed small :color="warning ? 'warning' : 'primary'" @click.native="validate()" :loading="loading" v-if="valid_button" >{{valid_label}}</v-btn>
                <v-btn round depressed small :color="warning ? 'warning' : 'primary'" @click.native="next_step()" :loading="loading" v-if="next_button" >Suivant</v-btn>
                <div v-else>

                </div>
                <v-btn round depressed small color="primary" v-if="more_action" @click.native="validate_add(false, currentView)" :loading="loading">{{more_action}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                isOpen:         false,
                currentView:    null,
                more_action:    null,
                params:         {},
                title:          null,
                icon:           null,
                width:          null,
                warning:        false,
                loading:        false,
                actions:        true,
                next_button:    false,
                valid_button:   true,
                valid_label:    "Valider",
                cancel_label:   "Annuler",
                cancel_button:  true,
                fullscreen:     false,
                card_text_class: ''
            }
        },

        methods: {
            close(type) {
                this.$refs.currentView.onClose(type)
            },

            validate() {
                this.loading = true

                if(!this.$refs.currentView.onValidate()) {
                    this.loading = false
                }
            },
            next_step() {
                this.loading = true

                if(!this.$refs.currentView.onNextStep()) {
                    this.loading = false
                }
            }

        },

        created() {
            this.$eventHub.$on('open-modal2', (component, params = {}) => {
                this.isOpen         = true
                this.currentView    = component
                this.params         = params

                this.title          = this.currentView.data().title         || null
                this.icon           = this.currentView.data().icon          || null
                this.width          = this.currentView.data().width         || '750px'
            this.fullscreen     = this.currentView.data().fullscreen        || false
                this.warning        = this.currentView.data().warning       || false
                this.more_action    = this.currentView.data().more_action   || null
                this.actions        = this.currentView.data().actions       || true
                this.next_button    = this.currentView.data().next_button   || false;
                this.cancel_button  = this.currentView.data().cancel_button=== false ?  false : true;
                this.valid_button   = this.currentView.data().valid_button === false ?  false : true;
                this.valid_label   = this.currentView.data().valid_label ? this.currentView.data().valid_label : "Valider";
                this.cancel_label   = this.currentView.data().cancel_label ? this.currentView.data().cancel_label : "Annuler";
                this.card_text_class   = this.currentView.data().card_text_class || 'small-modal-text';


            })

            this.$eventHub.$on('close-modal2', () => {
                this.loading        = false
                this.isOpen         = false

                setTimeout(() => { this.currentView = null }, 500)
            })

            this.$eventHub.$on('hide-modal2-actions', () => {
                this.actions = false
            })

            this.$eventHub.$on('set-next-button', params => {
                this.next_button = params
            })

            this.$eventHub.$on('set-valid-button', params => {
                this.valid_button = params
            })
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    .dialog {
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px
        .card {
            .card__title {
                justify-content: space-between
                padding: 1.5rem 2rem
                background: $primary-color

                h2 {
                    display: flex
                    align-items: center
                    margin: 0
                    color: #fff
                    font-size: 1.8rem
                    font-weight: 500

                    .icon {
                        margin: 0 1.5rem 0 0
                        font-size: 3rem
                        color: #fff !important
                    }
                }

                button {
                    margin: 0

                    .icon {
                        font-size: 2rem
                        color: #fff
                    }
                }
            }

            .card__text.small-modal-text {
                padding: 3rem 2rem
            }

            .card__text.fullscreen-modal-text {
                padding: 0
            }

            .card__actions {
                display: flex;
                justify-content: flex-end;
                padding: 1.5rem 2rem

                button:last-of-type {
                    margin-right: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Modal2.vue